module.exports = __webpack_public_path__ + "img/jr-1.07bfe7c1.jpg";